// We need empty file to have proper submodules
// "types" field in package.json will point to this file.
// Also, without this file many code editors will fail.
// Look into this thread for more details
// https://github.com/Microsoft/TypeScript/issues/2568
// Common
export { fetchData, formatRangeHeader, makeGet, makeRangeHeader, makeRequest, makeSearchParams, parseContentRangeResponse } from './util';
//# sourceMappingURL=index.js.map